import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, useAsync, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useVuetify } from "@/composables";
import { getLtksStore } from "@/store/ltks";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkFeedItem',
  props: {
  ltkId: {
    type: String,
    required: true,
  },
  position: {
    type: Number,
    required: false,
    default: undefined,
  },
  showProducts: {
    type: Boolean,
    required: false,
    default: false,
  },
  showAvatar: {
    type: Boolean,
    required: false,
    default: false,
  },
  showAvatarFollowers: {
    type: Boolean,
    required: false,
    default: false,
  },
  showTitle: {
    type: Boolean,
    required: false,
    default: false,
  },
  singleColumnXs: {
    type: Boolean,
    required: false,
    default: false,
  },
  denseFeed: {
    type: Boolean,
    required: false,
    default: false,
  },
  numProductsDisplayed: {
    type: Number,
    required: false,
    default: 3,
  },
  onIntersecting: {
    type: Function as PropType<(entries: Array<IntersectionObserverEntry>) => null>,
    required: false,
    default: () => null,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const route = useRoute();
const amplitude = useAmplitude();
const vuetify = useVuetify();
const HERO_IMAGE_DEFAULT_WIDTH = 450;
const HERO_IMAGE_HALF_WIDTH = 225;
const optimizedWidth = computed(() =>
  // if the screen is xs and singleColummnXs isn't true only request half width images
  vuetify.breakpoint.xsOnly && !props.singleColumnXs ? HERO_IMAGE_HALF_WIDTH : HERO_IMAGE_DEFAULT_WIDTH,
);

const ltk = computed(() => getLtksStore(store).ltks[props.ltkId]);
const isVideo = computed(() => Boolean(ltk.value?.videoMediaId !== undefined && ltk.value?.videoMediaId !== null));
const displayName = computed(() => getProfilesStore(store).getDisplayNameById(ltk.value?.profileId));
const allProductIds = computed(() => getLtksStore(store).ltks[props.ltkId]?.productIds ?? []);
const productIds = computed(() =>
  hasMoreProducts.value ? allProductIds.value.slice(0, props.numProductsDisplayed) : allProductIds.value,
);
const totalProducts = computed(() => allProductIds.value.length);
const hasMoreProducts = computed(() => totalProducts.value > props.numProductsDisplayed + 1);
const referringComponent = computed(() => {
  if (route.value.name === "explore-displayName-posts-id") {
    return amplitude?.getReferringComponentByPage(route.value.name ?? "", "related posts section");
  }
  if (route.value.name === "search") {
    const section = route.value.query.type === "post" ? "post" : "creator";
    return amplitude?.getReferringComponentByPage(route.value.name ?? "", section);
  }

  return amplitude?.getReferringComponentByPage(route.value.name ?? "");
});

useAsync(() => getLtksStore(store).fetchLtkByIdAggregate({ id: props.ltkId }), "LtkFeedItem");

return { __sfc: true,props, store, route, amplitude, vuetify, HERO_IMAGE_DEFAULT_WIDTH, HERO_IMAGE_HALF_WIDTH, optimizedWidth, ltk, isVideo, displayName, allProductIds, productIds, totalProducts, hasMoreProducts, referringComponent }
}

})